import { ButtonSuccessStyle } from '../styles'
import SendApproveButtonHook from './SendApproveButton.hook'
import IncompleteApprovalModal from '../IncompleteApprovalModal'

const SendApproveButton = () => {
  const {
    handleClickApprove,
    isHideButton,
    isIncompleteModalVisible,
    handleIncompleteModalClose,
    handleIncompleteModalEdit,
  } = SendApproveButtonHook()

  if (isHideButton) {
    return null
  }

  return (
    <>
      <ButtonSuccessStyle onClick={handleClickApprove}>ส่งอนุมัติ</ButtonSuccessStyle>
      <IncompleteApprovalModal
        open={isIncompleteModalVisible}
        onCancel={handleIncompleteModalClose}
        onEdit={handleIncompleteModalEdit}
      />
    </>
  )
}

export default SendApproveButton
